<template>
    <v-dialog class="dialog" v-model="dialog" max-width="290" origin="top top">
        <v-card>
            <v-card-title class="text-h5">{{ getTranslatedText(title) }}</v-card-title>

            <v-card-text> {{ getTranslatedText(description) }} </v-card-text>

            <v-card-actions>
                <ButtonCommon
                    :value="textButtonCancel"
                    class-name="dialog__box-button__item uppercase"
                    name-function="on-hide-dialog"
                    :isNoHover="true"
                    :isDisable="isLoadingButton"
                />
                <ButtonCommon
                    :value="textButtonSubmit"
                    type="error"
                    class-name="dialog__box-button__item uppercase"
                    nameFunction="on-confirm-ok"
                    :isNoHover="true"
                    :isLoading="isLoadingButton"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import languageMixins from '@/mixins/language/language-mixins'
import EventBus from '@/utils/EventBus'
import ButtonCommon from '@/components/common/button/index.vue'
import { isStrEmpty } from '@/utils/utils'

export default {
    mixins: [languageMixins],
    components: { ButtonCommon },
    data() {
        return {
            dialog: false,
            title: 'Confirmation',
            description: 'Clear all bets?',
            textButtonSubmit: 'Yes',
            textButtonCancel: 'no',
            isLoadingButton: false,
            nameFunction: '',
            nameFunctionCancel: '',
            paramFunction: null,
        }
    },
    created() {
        EventBus.$on('on-show-dialog', (param) => this.onChangeValue(param))
        EventBus.$on('on-change-value-dialog', (param) => this.onChangeValue(param))
        EventBus.$on('on-hide-dialog', () => this.onCancelPopup())
        EventBus.$on('on-confirm-ok', () => this.onConfirmOk())
        EventBus.$on('on-close-popup', (this.dialog = false))
    },
    destroyed() {
        EventBus.$off('on-show-dialog')
        EventBus.$off('on-hide-dialog')
        EventBus.$off('on-confirm-ok')
    },
    methods: {
        onCancelPopup() {
            if (!isStrEmpty(this.nameFunctionCancel)) {
                EventBus.$emit(this.nameFunctionCancel)
                return
            }

            this.dialog = false
        },

        onChangeValue(param) {
            this.dialog = true
            if (!isStrEmpty(param.title)) this.title = param.title
            if (!isStrEmpty(param.description)) this.description = param.description
            if (!isStrEmpty(param.textButtonSubmit)) this.textButtonSubmit = param.textButtonSubmit
            if (!isStrEmpty(param.textButtonCancel)) this.textButtonCancel = param.textButtonCancel
            if (!isStrEmpty(param.nameFunction)) this.nameFunction = param.nameFunction
            if (!isStrEmpty(param.nameFunctionCancel)) this.nameFunctionCancel = param.nameFunctionCancel
            if (param.paramFunction) this.paramFunction = param.paramFunction
            this.isLoadingButton = param?.isLoadingButton
        },

        onConfirmOk() {
            EventBus.$emit(this.nameFunction, this.paramFunction)
            if (!this.paramFunction?.isNotClosePopup) {
                this.dialog = false
            }
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/common/_dialog.scss';
</style>
